import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireSubscription?: boolean;
  isAdmin: boolean;
  isSubscriber: boolean;
  loading: boolean;
  fallback?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
  requireSubscription = false,
  isAdmin,
  isSubscriber,
  loading,
  fallback,
}) => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const location = useLocation();

  if (loading || authStatus === 'configuring') {
    return <div className="loading">Checking access...</div>;
  }

  if (authStatus !== 'authenticated') {
    // Where they were going, so signing in can bring them back to it (#948).
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireSubscription && !isSubscriber && !isAdmin) {
    return fallback ? <>{fallback}</> : <Navigate to="/pricing" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
